import React from "react";
import styled from "styled-components";

const GridStyle = styled.div`
    width: 100%;
    display: grid;
    align-items: end;
    grid-row-gap: 14px;
    grid-column-gap: 8px;
    grid-template-columns: ${props => (
        props.$template !== undefined
            ? props.$template
            : `repeat(${props.$columns}, 1fr)`
    )};
`;

export const Grid = React.memo(props => {

    const { children, columns, template } = props;

    if (columns !== undefined && template !== undefined) {
        throw new Error("Grid: use either 'columns' or 'template', not both.");
    }
    if (columns === undefined && template === undefined) {
        throw new Error("Grid: either 'columns' or 'template' must be provided.");
    }
    return (
        <GridStyle
            $columns={columns}
            $template={template} >
            {children}
        </GridStyle>
    );
});